<template>
  <div>
    <b-card>
      <b-card-title>RECIBO</b-card-title>
      <b-card-text>
        <b-row>
          <b-col>
            Recebemos de {{ bill_data.bill.person.name }}
            <span v-if="!isJuridic"
              >portador do CPF: {{ person_document | cpf }}
            </span>
            <span v-if="isJuridic">
              portador do CNPJ: {{ person_document | cnpj }} </span
            >, a importância de
            {{ bill_data.bill.payed_value | moneyBr }}
            ({{ bill_data.bill.payed_value | decimal | extenso }})
            correspondente ao documento/parcela Nº
            {{ bill_data.bill.document }}.

            <template v-if="hasOrder">
              <br />
              referente a:
              <br />
              <table class="table table-sm col-12">
                <thead>
                  <tr>
                    <th>Produto</th>
                    <th>Qt</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, index) in bill_data.products" :key="index">
                    <td class="col-11">{{ row.product }}</td>
                    <td class="col-1">{{ row.quantity }}</td>
                  </tr>
                </tbody>
              </table>
            </template>
          </b-col>
        </b-row>
        <br />

        <b-row>
          <b-col>
            {{ company.address.city }} -
            {{ bill_data.bill.payed_at | dateBr }}
          </b-col>
        </b-row>
        <hr />
        <b-row>
          <b-col
            >{{ company.name }} <br />
            CNPJ: {{ company.cnpj | cnpj }}</b-col
          >
        </b-row>
        <b-row>
          <b-col>
            {{ company.address.address }}, {{ company.address.number }}
            {{ company.address.district }} - {{ company.address.city }}-{{
              company.address.state
            }}
            <br />
            - CEP:
            {{ company.address.zipcode | cep }}
            <span v-if="company.address.complement"
              >,{{ company.address.complement }}</span
            >
          </b-col>
          <br />
        </b-row>
      </b-card-text>
    </b-card>
  </div>
</template>

<script>
export default {
  props: {
    bill_data: {
      type: Object,
    },
  },

  computed: {
    company() {
      return this.$store.state.company;
    },
    hasOrder() {
      return this.bill_data.bill.order_id != null;
    },

    isJuridic() {
      return this.bill_data.bill.person.person_type == "j";
    },

    person_document() {
      if (this.isJuridic) {
        return this.bill_data.bill.person.cnpj
          ? this.bill_data.bill.person.cnpj
          : "";
      }
      if (!this.isJuridic) {
        return this.bill_data.bill.person.cpf
          ? this.bill_data.bill.person.cpf
          : "";
      }
    },
  },
};
</script>

<style scoped>
.card {
  width: 80mm;
}
h4.card-title {
  text-align: center;
}

@media print {
  .card {
    width: 40%;
    height: 100%;
    border: none;
    font-weight: 900;
    text-align: justify;
    font-family: "Arial", sans-serif;
  }
  .card-title {
    font-weight: 900;
  }
  /* .card-text {
    padding-bottom: 5cm;

    font-family: Arial;
    font-size: 2mm;
    font-style: normal;
    font-variant: normal;
    font-weight: 700;
  }

  h4.card-title {
    font-weight: 900;
    text-align: center;
  }
  .card {
    size: "RP80x297";
    break-after: avoid;

    border: none;
    width: 100mm;
  }
  div.col {
    padding: 4mm;
    font-size: 12pt;
    font-weight: 900;
  }

  .page {
    font-weight: 900;
    width: initial;
    min-height: initial;
    page-break-after: always;
    box-shadow: initial;
    break-after: avoid;

    size: "RP80x297";
 
  } */
  .table {
    font: 10pt;
    border-collapse: collapse;
  }
  table,
  th,
  td {
    border: 1px solid;
  }
  .not-print {
    display: none;
  }
}
</style>
